import { hoursInDay } from 'utils/dateTime';

const bufferHours = 2;
export default hoursInDay + bufferHours;
